import { Severity } from 'framework/entities/healthData';
import { i18n } from 'core/localization';

export function severityToText(severity: Severity) {
	switch (severity) {
		case Severity.None:
			return i18n('None');
		case Severity.Minor:
			return i18n('Minor');
		case Severity.Major:
			return i18n('Major');
		case Severity.Critical:
			return i18n('Critical');
		case Severity.Invalid:
			return i18n('Invalid');
	}
}
